import * as React from 'react';

import { Banner, BannersProvider } from 'features/banners';

function BannersPage(): JSX.Element {
  return (
    <BannersProvider>
      <main className="banners-page">
        <Banner />
      </main>
    </BannersProvider>
  );
}

export default BannersPage;
export { BannersPage };
